// animation
import { Fade } from "react-awesome-reveal";
import { BabyHead, HeadSet, LadyLogo } from "utils/Icons";

const StepSix = ({
  formData,
  emotionsData,
  agesData,
  setActiveStep,
  frequencyList,
}) => {
  //show emotions which are selected by a user to show relative titles.
  const getTitles = () => {
    let newObj = [];
    emotionsData.map((v) => {
      if (formData?.emotions?.includes(v?._id)) {
        newObj.push(v);
      }
    });
    return newObj;
  };

  //   create a frequency title
  const getFrequencyTitle = () => {
    return frequencyList?.find(
      (frequency) => frequency?.name === formData.frequency
    );
  };

  // count total children
  const getTotal = (data) => {
    let s = 0;
    Object.values(data).map((v) => {
      if (v && v?.count) {
        s = s + v?.count;
      }
    });

    return s?.toString() === "0" ? "" : s;
  };

  //  check pregnant option is checked or not
  const isPregnant = () => {
    let isMatched = false;
    agesData?.map((v) => {
      if (v?.title === "Pregnancy") {
        let finds = Object.values(formData?.children)?.find(
          (s) => s.ageRange === v._id
        );
        if (finds) {
          isMatched = true;
        } else {
          isMatched = false;
        }
      }
    });

    return isMatched;
  };

  return (     
      <> 
      <div className="step_card_body justify_content_start">
        <Fade triggerOnce delay={400} duration={1200}>
          <h3 className="text_center">
            Almost done, mama! Let's <br /> save your preferences and <br />{" "}
            build your custom plan.
          </h3>
        </Fade>
        <br />
        <Fade triggerOnce cascade delay={1300}>
          <Fade triggerOnce delay={350}>
            <div className="cs_row">
              <div className="icon_shape cs_row">
                <LadyLogo />
              </div>
              <p className="result_text">
                You would like to
                {getTitles()
                  ?.slice(0, 3)
                  ?.map((v, i) => (
                    <span key={i}>
                      {" " + v?.title_positive}
                      {getTitles()?.slice(0, 3)?.length === i + 1 ? "" : ", "}
                    </span>
                  ))}
                {getTitles()?.length > 3 ? " and more." : "."}
              </p>
            </div>
          </Fade>
          <br />
          <Fade triggerOnce delay={650}>
            <div className="cs_row">
              <div className="icon_shape cs_row">
                <HeadSet />
              </div>
              <p className="result_text">
                You're going to use MamaZen <br />{" "}
                {getFrequencyTitle()?.mainTitle?.toLowerCase()}.
              </p>
            </div>
          </Fade>
          <br />
          <Fade triggerOnce delay={950}>
            <div className="cs_row">
              <div className="icon_shape cs_row">
                <BabyHead />
              </div>
              <p className="result_text">
                You'll be the best mom to your {getTotal(formData?.children)}{" "}
                amazing {getTotal(formData?.children) > 1 ? "kids" : `kid`}
                {isPregnant() ? " and the baby growing inside you!" : "."}
              </p>
            </div>
          </Fade>
        </Fade>
      </div>
      <br />
      <div className="mt_auto screen_sticky_footer">
        <Fade triggerOnce delay={1400} duration={1300}>
          <button onClick={() => setActiveStep(6)} className="cs_btn w_100">
            Continue
          </button>
        </Fade>
      </div>
    </>
  );
};

export default StepSix;
